import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  //-- 获取当前年份
  const currentYear = new Date().getFullYear();
  return (
    <DefaultFooter
      style={{
        background: "none",
      }}
      copyright={` Copyright ${currentYear} METAX SOFTWARE PTE.LTD.`}
      links={[
        // {
        //   key: "MetaX Analytics Dashboard",
        //   title: "MetaX Analytics Dashboard",
        //   href: "https://metaxsoft.com",
        //   blankTarget: true,
        // },
      ]}
    />
  );
};

export default Footer;
